import React, { Component } from "react";
import { SubMenuLink } from "./SubMenuLink";
import { ClientListIcon } from "../../Common/Icons";

export default class ClientsListLink extends Component {
  render() {
    return (
      <SubMenuLink pathname="/folders" title="clientsList">
        <ClientListIcon className={"light-sub-menu-icon"} />
      </SubMenuLink>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/ClientsListLink.js